/**
 * @description
 */

import Api from '../../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IInput {
    resource_id: number;
    url: string;
}

export interface IOutput {
    task_id: number;
}

export const pptToImg = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PPT_TO_IMG, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const pptToImgSync = fetchDataSync<IInput>(pptToImg);
